import { useContext } from 'react';
import { NotificationContext, NotifyFunc } from '../components/notifications/NotificationsProvider';

export default function useNotify(): NotifyFunc {
    return useContext(NotificationContext).notify;
}
